/**
 * Design System - Animation Tokens
 *
 * Transition durations, timing functions, and animation presets
 */

export const animations = {
  // Duration
  duration: {
    instant: '0ms',
    fast: '150ms',
    normal: '300ms',
    slow: '500ms',
    slower: '750ms',
  },

  // Timing Functions (Easing)
  easing: {
    linear: 'linear',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  },

  // Transition presets
  transition: {
    all: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    colors:
      'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1), border-color 300ms cubic-bezier(0.4, 0, 0.2, 1), color 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    opacity: 'opacity 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    transform: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    shadow: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
} as const;

// Component-specific animations
export const componentAnimations = {
  button: {
    hover: {
      transition: animations.transition.all,
      duration: animations.duration.fast,
    },
    press: {
      transition: animations.transition.transform,
      duration: animations.duration.instant,
    },
  },

  modal: {
    enter: {
      transition: animations.transition.opacity,
      duration: animations.duration.normal,
    },
    exit: {
      transition: animations.transition.opacity,
      duration: animations.duration.fast,
    },
  },

  dropdown: {
    enter: {
      transition: `${animations.transition.opacity}, ${animations.transition.transform}`,
      duration: animations.duration.fast,
    },
    exit: {
      transition: animations.transition.opacity,
      duration: animations.duration.fast,
    },
  },

  card: {
    hover: {
      transition: `${animations.transition.transform}, ${animations.transition.shadow}`,
      duration: animations.duration.normal,
    },
  },
} as const;

export type AnimationToken = typeof animations;
